import React from "react";
import { Player } from "@lottiefiles/react-lottie-player";
import animationData from "./processPDF.json"; // Adjust the path as needed

const ProcessPDFAnimation = () => {
  return (
    <div>
      <Player
        autoplay
        loop
        src={animationData}
        style={{ height: "200px", width: "200px" }}
      />
    </div>
  );
};

export default ProcessPDFAnimation;
